<!-- 滚轮横向滚动组件 -->
<template>
  <div class="horwheel-img">
    <div id="field">
      <!-- 天空云层部分 -->
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud4.png" class="absolute cloud-ani" alt="static" data-wd="901" data-left="1261" data-top="-20" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5.png" class="absolute cloud-ani" alt="static" data-wd="420" data-left="1951" data-top="179" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud10.png" class="absolute cloud-ani" alt="static" data-wd="1192" data-left="3900" data-top="-20" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud4_c.png" class="absolute cloud-ani" alt="static" data-wd="901" data-left="6000" data-top="-20" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5_c.png" class="absolute cloud-ani" alt="static" data-wd="400" data-left="5000" data-top="279" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5_c.png" class="absolute cloud-ani" alt="static" data-wd="400" data-left="3400" data-top="229" />
      <!-- 底图部分 -->
      <img id="field-long-img" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/bg1_7.jpg" />

      <!-- 前言 -->
      <div data-alt="speed" class="absolute left-0" data-wd="591" data-left="200" data-top="189">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/title.png" class="width-100" />
      </div>

      <!-- 汪部分 -->
      <div data-alt="speed" class="absolute left-0" data-wd="463" data-left="2069" data-top="130">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/talk4.png" class="width-100" />
      </div>
      <div data-alt="speed" class="absolute left-0 opacity-0" data-wd="180" data-left="1972" data-top="114" data-active="ani3" data-left-percentage="0.6" id="wang-talk1">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/wyb.gif" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="847" data-left="2412">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/wang/wang-person3.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0 cursor-pointer" data-wd="335" data-left="3150" data-top="107" @click="showModal('wang')">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/play-mp42.png" class="width-100" />
      </div>

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/talk4.png" id="field-msg-1" class="img-static-bg" alt="static" data-active="ani1" data-left-percentage="0.7" data-wd="124" data-left="4378" data-top="472" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/talk5.png" id="field-msg-2" class="img-static-bg" alt="static" data-active="ani1" data-left-percentage="0.7" data-wd="124" data-left="5401" data-top="437" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/talk6.png" id="field-msg-3" class="img-static-bg" alt="static" data-active="ani1" data-left-percentage="0.7" data-wd="180" data-left="5593" data-top="540" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/wang/peoples.png" class="absolute" alt="static" data-wd="1743" data-left="4004" />

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.8" data-wd="705" data-left="5970" data-top="127">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/talk2.png" class="width-100 opacity-0" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="343" data-left="6550" data-top="312">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/person1.png" class="width-100 " />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="air-ani" data-left-percentage="0.9" data-wd="655" data-left="6900" data-top="126">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/air.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" id="field-air" data-left-percentage="0.9" data-wd="0" data-left="7220" data-top="105">
        <div class="dot-ani cursor-pointer" @click="showAirTalk()"></div>
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="366" data-left="7100" data-top="341">
        <img id="air-talk" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/talk3.png" class="width-100 opacity-0" />
      </div>
      <!-- 陈部分 -->
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/chen/title1.png" class="absolute ani-shake2" alt="static" data-wd="308" data-left="7130" data-top="140" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/chen/pangxie.png" id="field-cai" class="img-static-bg" alt="static" data-active="ani2" data-left-percentage="0.6" data-wd="1341" data-left="7397" data-top="0" />

      <div data-alt="speed" class="absolute left-0" data-wd="455" data-left="9200" data-top="679">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/talk5.png" class="width-100" />
      </div>
      <div data-alt="speed" class="absolute left-0 opacity-0" data-wd="180" data-left="9400" data-top="877" data-active="ani3" data-left-percentage="0.6" id="chen-talk1">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/wyb.gif" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="791" data-left="9650">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/chen/person1.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.8" data-wd="366" data-left="10497" data-top="528">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/4/talk1.png" class="width-100 opacity-0" />
      </div>

      <div data-alt="speed" class="absolute left-0 cursor-pointer" data-wd="302" data-left="10297" data-top="143" @click="showModal('chen')">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/play-mp41.png" class="width-100" />
      </div>

      <!-- 直播部分 -->
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/live.png" class="live" />
      <div class="live-inner" id="live-inner">
        <div>我爱宁波购买水蜜桃1箱</div>
        <div>ILOVENB购买苹果2箱</div>
        <div>今天好心情购买苹果1箱</div>
        <div>飞翔购买水晶葡萄1箱</div>
        <div>秋寒购买水蜜桃1箱</div>
        <div>月湖垂钓购买水蜜桃2箱</div>
        <img class="live-like-btn" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/3/dianzan.png" @click="createHeart" />
        <!-- <span class="live-like-btn" @click="createHeart">👍</span> -->
      </div>
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/chen/live-title.png" class="img-static-bg" alt="static" data-active="ani1" data-left-percentage="0.9" data-wd="302" data-left="10205" data-top="270" />
      <!-- 采访部分 -->
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/hand2.png" class="absolute ani-opacity cursor-pointer" alt="static" data-wd="56" data-left="13362" data-top="386" @click="showMp3('field-ganyan')" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/person2.png" class="absolute cursor-pointer" alt="static" data-wd="477" data-left="13334" data-top="167" @click="showMp3('field-ganyan')" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/q1.png" class="absolute cursor-pointer opacity-0" alt="static" data-wd="367" data-left="11889" data-top="850" @click="handleAnswer1()" :class="{ ani1: question1 }" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/q2.png" class="absolute cursor-pointer opacity-0" alt="static" data-wd="408" data-left="12335" data-top="649" @click="handleAnswer2()" :class="{ ani1: question2 }" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/c2.png" class="absolute cursor-pointer" alt="static" data-wd="328" data-left="12376" data-top="661" @click="changeFlag('question2')" :class="{ 'z-index--1': question2 }" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/c1.png" class="absolute cursor-pointer" alt="static" data-wd="302" data-left="11939" data-top="869" @click="changeFlag('question1')" :class="{ 'z-index--1': question1 }" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/a1.png" class="absolute opacity-0" alt="static" data-wd="507" data-left="11476" data-top="91" :class="{ ani1: answer1, 'z-index--1': !answer1 }" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/a2.png" class="absolute opacity-0" alt="static" data-wd="562" data-left="12703" data-top="41" :class="{ ani1: answer2, 'z-index--1': !answer2 }" />
    </div>
    <img v-if="showMouseTip" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mouse.png" class="mouse-tip ani-opacity" />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// 横向滚动视差滚动对象
let parallax = {
  segment: 15,
  screenWidth: 0,
  dom: null,
  speed: 0.5,
  scrollLeft: 0,
  scrollLeftWithScreen: 0,
  scrollMaxLeft: 0,
  wheelStep: 0,
  minStep: 0,
  curStep: 0,
  longImgWidth: 0,
  longImgRealWidth: 14078,
  longImgRealHeight: 1080,
  imgScale: 1,
  layers: [],
  staticDoms: [],
  music: [],
  extraDom: []
}
let timer
let doingNextMove = false
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      showMouseTip: true,
      end: false,
      question1: false,
      question2: false,
      answer1: false,
      answer2: false
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    showAirTalk() {
      const airTalk = document.getElementById('air-talk')
      if (airTalk.classList.contains('ani1')) {
        airTalk.classList.remove('ani1')
      } else {
        airTalk.classList.add('ani1')
      }
    },
    handleAnswer1() {
      this.answer1 = true
      this.answer2 = false
    },
    handleAnswer2() {
      this.answer1 = false
      this.answer2 = true
    },
    reset() {
      if (this.showMouseTip) return
      this.end = false
      this.question1 = false
      this.question2 = false
      this.answer1 = false
      this.answer2 = false
      this.showMouseTip = true
      const airTalk = document.getElementById('air-talk')
      if (airTalk.classList.contains('ani1')) {
        airTalk.classList.remove('ani1')
      }
      parallax.layers = []
      parallax.staticDoms = []
      parallax.music = []
      parallax.extraDom = []
      parallax.dom.style.transform = `translate3d(0, 0, 0)`
      parallax.scrollLeft = 0
      parallax.curStep = 0
      this.init()
    },
    changeFlag(flag) {
      this[flag] = !this[flag]
      console.log('flag:', flag, this[flag])
    },
    init() {
      this.aniInit()
      this.wheelInit()
    },
    createHeart(event) {
      const parentDom = document.getElementById('live-inner')
      const heartContainer = document.createElement('span')
      heartContainer.className = 'heart-container'
      parentDom.appendChild(heartContainer)
      const heart = document.createElement('span')
      heart.innerHTML = '❤️'
      heart.className = 'heart'
      heartContainer.appendChild(heart)

      const xPos = Math.random() * 40 + 45
      const duration = Math.random() * 0.6 + 2
      heartContainer.style.right = xPos + 'px'
      setTimeout(() => {
        heartContainer.remove()
      }, duration * 3000)
    },
    showMp3(mode) {
      if (this.answer1) {
        this.answer1 = false
      }
      if (this.answer2) {
        this.answer2 = false
      }
      const items = ['我们滕头村人常说，一村富不算富，一个人富也不算富，大家一起富才是真正的富。', '这就需要新一代农创客，把好的技术、好的想法、好的理念，通过自己的实践带给更多的村民，带领村民一起走上更加幸福宽广的道路。']
      const name = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/ganyan/fpj/name.png'
      const avatar = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/ganyan/fpj/avatar.png'
      const mp3Gif = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/fpj.gif'
      const color = '#2754bf'
      const dang = '党的二十大代表'
      this.$emit('openMp3Modal', { mode, items, name, avatar, mp3Gif, color, dang })
    },
    showModal(mode) {
      let backgroundColor = ''
      let titleImg = ''
      let videoUrl = ''
      if (mode === 'wang') {
        backgroundColor = '#f4bc45'
        titleImg = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/wang/modal-title.png'
        videoUrl = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/field/wang.mp4'
      } else {
        backgroundColor = '#68bfff'
        titleImg = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/wang/modal-title.png'
        videoUrl = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/field/chen.mp4'
      }
      this.$emit('openModal', { mode, backgroundColor, titleImg, videoUrl })
    },
    aniInit() {},
    wheelInit() {
      // 获取监听滚轮事件
      parallax.dom = document.getElementById('field')
      // 获取主要滚动dom
      const image = document.getElementById('field-long-img')
      // console.log('image.width：', image.width)
      parallax.longImgWidth = image.width
      parallax.dom.style.width = image.width + 'px'
      parallax.imgScale = image.width / parallax.longImgRealWidth
      // 获取屏幕宽度
      parallax.screenWidth = window.innerWidth || (document.body && document.body.clientWidth)
      // 最大滚动到左侧距离
      parallax.scrollMaxLeft = parallax.longImgWidth - parallax.screenWidth
      // 每一次距离(屏幕宽度 / 15 * 速率)
      parallax.wheelStep = (parallax.screenWidth / parallax.segment) * parallax.speed
      // 滚动最小距离
      parallax.minStep = parallax.screenWidth / 1000 / parallax.segment
      // 获取滚动到长图的距离 首次进入就是宽度
      parallax.scrollLeftWithScreen = parallax.screenWidth
      // 获取所有要滚动的图片
      this.initChildren()
      console.log('field-parallax:', parallax)
      // 添加滚轮监听事件
      parallax.dom.addEventListener('wheel', this.handleWheel)
    },
    initPosition(element) {
      const realWidth = element.getAttribute('data-wd')
      const realLeft = element.getAttribute('data-left')
      const realTop = element.getAttribute('data-top')
      if (element.hasAttribute('data-wd')) {
        element.style.width = (realWidth / parallax.longImgRealWidth) * 100 + '%'
      }
      element.style.left = (realLeft / parallax.longImgRealWidth) * 100 + '%'
      if (element.hasAttribute('data-top')) {
        element.style.top = (realTop / parallax.longImgRealHeight) * 100 + '%'
      } else {
        element.style.bottom = 0
      }
    },
    initChildren() {
      // 配置图片
      for (let i = 0; i < parallax.dom.children.length; i++) {
        const element = parallax.dom.children[i]
        if (element.getAttribute('data-alt') === 'speed') {
          // 处理动态
          const speed = element.getAttribute('speed') || 1.1
          const realWidth = element.getAttribute('data-wd')
          const realLeft = element.getAttribute('data-left')
          const realTop = element.getAttribute('data-top')
          const layer = {
            dom: element,
            realWidth,
            realLeft,
            speed: Number(speed),
            width: realWidth * parallax.imgScale,
            left: realLeft * parallax.imgScale,
            initLeft: realLeft * parallax.imgScale
          }
          parallax.layers.push(layer)
          // 处理div节点样式
          element.style.width = layer.width + 'px'
          if (element.hasAttribute('data-top')) {
            element.style.top = (realTop / parallax.longImgRealHeight) * 100 + '%'
          } else {
            element.style.bottom = 0
          }
          element.style.transform = `translate3d(${layer.left}px, 0, 0)`
          // 处理内层动画节点样式
          const imgDom = element.children[0]
          const activeClass = element.getAttribute('data-active')
          if (!activeClass) continue
          if (imgDom.classList.contains(activeClass)) {
            imgDom.classList.remove(activeClass)
          }
          const leftPercentage = element.getAttribute('data-left-percentage') || 0.7
          parallax.staticDoms.push({
            dom: imgDom,
            activeClass,
            leftPercentage,
            active: false
          })
        } else if (element.alt === 'static') {
          // 处理静态
          this.initPosition(element)
          const activeClass = element.getAttribute('data-active')
          if (!activeClass) continue
          if (element.classList.contains(activeClass)) {
            element.classList.remove(activeClass)
          }
          parallax.staticDoms.push({
            dom: element,
            activeClass,
            leftPercentage: element.getAttribute('data-left-percentage') || 0.7,
            active: false
          })
        } else if (element.getAttribute('data-alt') === 'position') {
          this.initPosition(element)
        }
      }
      // 初始化音乐
      const musicContainer = document.getElementById('field-music-contianer')
      const audioElements = musicContainer.getElementsByTagName('audio')
      for (var i = 0; i < audioElements.length; i++) {
        const element = audioElements[i]
        const imgDom = document.getElementById(element.getAttribute('data-img'))
        const activeClass = imgDom.getAttribute('data-active')
        if (imgDom.classList.contains(activeClass)) {
          imgDom.classList.remove(activeClass)
        }
        parallax.music.push({
          audioId: element.id,
          dom: element,
          played: false,
          ended: false,
          imgDom: imgDom,
          endPlayLeft: element.getAttribute('data-end-left') * parallax.imgScale,
          leftPercentage: imgDom.getAttribute('data-left-percentage'),
          activeClass
        })
      }
    },
    listenerAnimation() {
      // 获取所有静态dom
      const { screenWidth } = parallax
      for (let i = 0; i < parallax.staticDoms.length; i++) {
        const item = parallax.staticDoms[i]
        if (item.active) continue
        const element = item.dom
        if (element.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          element.classList.add(item.activeClass)
          item.active = true
        }
      }
      // 获取所有音乐dom
      for (let i = 0; i < parallax.music.length; i++) {
        const item = parallax.music[i]
        const imgDom = item.imgDom
        // 已经结束的就跳过
        if (item.ended) continue
        // 正在播放的需要判断结束位置
        if (item.played) {
          //判断停止位置是否到达
          if (parallax.scrollLeftWithScreen >= item.endPlayLeft) {
            // item.dom.pause()
            this.$emit('playAudio', item.dom)
            item.ended = true
          }
          continue
        }
        if (imgDom.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          // item.dom.play()
          this.$emit('playAudio', item.dom)
          item.played = true
          if (item.activeClass) {
            imgDom.classList.add(item.activeClass)
          }
        }
      }
      // 获取所有特殊的dom
      for (let i = 0; i < parallax.extraDom.length; i++) {
        const item = parallax.extraDom[i]
        if (item.active) continue
        const element = item.dom
        if (element.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          item.active = true
          item.beginAni && item.beginAni()
        }
      }
    },
    handleWheel(event) {
      if (this.showMouseTip) {
        this.showMouseTip = false
      }
      event.preventDefault()
      // 监听动画效果
      this.listenerAnimation()
      // 判断是否前进后退
      const isForward = event.wheelDeltaY < 0
      // 根据滚动距离修改当前位置
      parallax.curStep = parallax.curStep + (isForward ? 1 : -1) * parallax.wheelStep
      // 限制移动范围，防止移动超出图片边界
      parallax.curStep = Math.max(0, Math.min(parallax.curStep, parallax.scrollMaxLeft))
      if (!this.end && parallax.curStep === parallax.scrollMaxLeft) {
        this.end = true
        this.$emit('end')
      }
      // console.log(parallax.curStep)
      doingNextMove = true
      timer || (timer = setInterval(() => this.changeScrollLeft(), 17))
    },
    changeScrollLeft() {
      const step = (parallax.curStep - parallax.scrollLeft) / parallax.segment
      // 如果滚动步长的绝对值大于设定的最小步长。
      if (Math.abs(step) > parallax.minStep) {
        parallax.scrollLeft += step
        parallax.scrollLeftWithScreen += step
        parallax.dom.style.transform = `translate3d(${-parallax.scrollLeft}px, 0, 0)`
        // 调整layers
        for (let i = 0; i < parallax.layers.length; i++) {
          const layer = parallax.layers[i]
          const element = layer.dom
          // todo是否需要去除
          // if (layer.dom.getBoundingClientRect().left >= parallax.screenWidth) {
          //   continue
          // }
          // if (!layer.active && element.getBoundingClientRect().left < parallax.screenWidth * layer.leftPercentage) {
          //   element.classList.add(layer.activeClass)
          //   layer.active = true
          // }
          if (layer.speed > 0 && layer.speed < 1) {
            layer.left = layer.initLeft + parallax.scrollLeft * (1 - layer.speed)
          } else {
            layer.left = layer.initLeft - parallax.scrollLeft * (layer.speed - 1)
          }
          layer.dom.style.transform = `translate3d(${layer.left}px, 0, 0)`
        }
      } else if (doingNextMove) {
        console.log('doingNextMove')
        // 如果当前滚动步长小于等于最小步长，并且标志表明有下一个移动要进行。
        doingNextMove = false
        clearInterval(timer)
        timer = null
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // console.log('created');
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.wheelInit();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    if (timer) {
      clearInterval(timer)
    }
    parallax.dom.removeEventListener('wheel', this.handleWheel)
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.horwheel-img {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  #field {
    width: 100%;
    height: 100%;
    position: relative;
  }
  #field-long-img {
    height: 100%;
  }

  .mouse-tip {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 7%;
    transform: translate(-50%, -50%);
  }

  .video-bg {
    position: absolute;
    top: 0;
    height: 100%;
    background: transparent;
  }
  .img-speed-bg {
    position: absolute;
    left: 0;
  }
  .video-bg1 {
    left: 1.75%;
    width: 6.748566%;
  }
  .img-static-bg {
    position: absolute;
    opacity: 0;
  }

  .live {
    width: 4.99%;
    position: absolute;
    bottom: 0;
    left: 73.2%;
  }
  .live-inner {
    width: 3.3%;
    position: absolute;
    bottom: 6%;
    left: 73.9%;
    height: 74.09%;
    transform: rotate(-11deg);
    overflow: hidden;
    & > div {
      position: absolute;
      white-space: nowrap;
      color: #fff;
      text-shadow: 2px 3px 5px #0a0a0a;
      font-size: 24px;
      right: -100%;
    }
    & > div:nth-child(1) {
      top: 13%;
      animation: danmu 10s linear infinite;
      animation-delay: 0s;
    }
    & > div:nth-child(2) {
      top: 20%;
      animation: danmu 9s linear infinite;
      animation-delay: 1s;
    }
    & > div:nth-child(3) {
      top: 46%;
      animation: danmu 11s linear infinite;
      animation-delay: 2s;
    }
    & > div:nth-child(4) {
      top: 55%;
      animation: danmu 12s linear infinite;
      animation-delay: 3s;
    }
    & > div:nth-child(5) {
      top: 65%;
      animation: danmu 8s linear infinite;
      animation-delay: 4s;
    }
    & > div:nth-child(6) {
      top: 78%;
      animation: danmu 13s linear infinite;
      animation-delay: 5s;
    }
    @keyframes danmu {
      from {
        right: -100%;
      }
      to {
        right: 100%;
      }
    }
    .live-like-btn {
      cursor: pointer;
      width: 33%;
      // font-size: 40px;
      position: absolute;
      right: 25px;
      bottom: 20px;
      user-select: none;
    }
  }

  .dot-ani {
    position: absolute;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #fff;
    z-index: 1;
  }
}

@keyframes flipCardRight {
  0% {
    transform: rotateY(-80deg);
    opacity: 0;
  }
  100% {
    transform: rotateY(20deg);
    opacity: 1;
  }
}

@keyframes flipCardLeft {
  0% {
    transform: rotateY(80deg);
    opacity: 0;
  }
  100% {
    transform: rotateY(-20deg);
    opacity: 1;
  }
}

.air-ani {
  animation: rotateAndMove 4s infinite linear;
}
@keyframes rotateAndMove {
  0% {
    transform: rotate(0deg) translate(0, 0);
  }
  25% {
    transform: rotate(5deg) translate(5px, -5px);
  }
  50% {
    transform: rotate(0deg) translate(0, 0);
  }
  75% {
    transform: rotate(-5deg) translate(-5px, 5px);
  }
  100% {
    transform: rotate(0deg) translate(0, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Field/index.vue